import { ReactElement } from 'react';
import { Stack, StackProps, styled } from '@mui/material';

import { PoolLink } from '../pool-link/pool-link';

const StyledPoolLink = styled(PoolLink)(() => ({
    '&:hover': {
        color: 'inherit',
    },
}));

const StyledContainer = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'column',
    minWidth: 287,
    maxWidth: 489,
    border: `1.5px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    flex: 1,

    [theme.breakpoints.up('sm')]: {
        transition: 'box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&:hover': {
            boxShadow: '0px 2px 14px 0px #21272E42',
        },
    },

    [theme.breakpoints.down('sm')]: {
        height: '100%',
    },
}));

export type PoolCardProps = StackProps & {
    href?: string;
};

export const PoolCard = (props: PoolCardProps): ReactElement => {
    const { href, ...stackProps } = props;

    return (
        <StyledPoolLink href={href}>
            <StyledContainer alignItems={'stretch'} {...stackProps} />
        </StyledPoolLink>
    );
};
